<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <span
          :class="[
            'bmd-form-group mb-2 d-block form-label-group',
            contrsearch_country_focus ? 'focused' : '',
          ]"
        >
          <v-select-popup
            type="country"
            v-model="attis_contragents.country"
            :placeholder="$t('message.contracts.country')"
          />

          <!-- <v-select id="fm1_oper_1code" :options="countries" label="display_text" :class="['form-control', typeof attis_contragents.country !== 'undefined' && attis_contragents.country.value!==''?'vs--selected':'']" @search=fetchCountries v-model="attis_contragents.country" :placeholder="$t('message.contracts.country')" @focus="contrsearch_country_Focused" @blur="contrsearch_countryBlurred"></v-select>	 -->
          <!-- <label for="fm1_memb_country" class="form-label-group-label shorter">{{$t('message.contracts.country')}}</label> -->
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            id="city"
            v-model="attis_contragents.city"
            :placeholder="$t('message.contracts.city')"
            autocomplete="off"
            style="cursor: auto"
          />
          <label for="city" class="form-label-group-label">{{
            $t("message.contracts.city")
          }}</label>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            id="sphere"
            v-model="attis_contragents.sphere"
            :placeholder="$t('message.contracts.sphere')"
            autocomplete="off"
            style="cursor: auto"
          />
          <label for="sphere" class="form-label-group-label">{{
            $t("message.contracts.sphere")
          }}</label>
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            id="contrsearchname"
            v-model="attis_contragents.name"
            :placeholder="$t('message.contracts.contr_search_name')"
            autocomplete="off"
            style="cursor: auto"
          />
          <label for="contrsearchname" class="form-label-group-label">{{
            $t("message.contracts.contr_search_name")
          }}</label>
        </span>
      </div>
    </div>
    <span :class="['bmd-form-group mb-2 d-block form-check']">
      <label class="form-check-label">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="attis_contragents.search_other"
        />
        <div>{{ $t("message.contracts.search_other") }}</div>
        <span class="form-check-sign">
          <span class="check"></span>
        </span>
      </label>
    </span>
    <button
      :class="[
        'btn',
        'btn-success',
        'btn-round',
        'btn-sm',
        'position-relative',
        search_loading ? 'pl-5' : '',
      ]"
      @click="searchContr"
      id="init_search"
    >
      <div
        class="loading loading-button"
        v-if="search_loading"
        style="margin-top: -2px; left: 16px"
      ></div>
      {{ $t("message.contracts.search") }}
    </button>
    <button
      class="btn btn-primary btn-round btn-sm ml-4"
      :disabled="aml_disabled"
      @click="check_aml"
      id="check_aml"
    >
      {{ $t("message.contracts.contract_check_contragent").split(" ")[0] }}
    </button>

    <br /><br />
    <div
      v-if="
        typeof contragents_search_results == 'object' &&
        contragents_search_results.length > 0
      "
    >
      <h5>{{ $t("message.contracts.search_results") }}</h5>
      <b-table
        responsive
        :fields="search_results_fields"
        :items="contragents_search_results"
        :per-page="perPage"
        :current-page="currentPage"
      >
        <template v-slot:cell(checked)="data">
          <input type="checkbox" v-model="data.item.checked" />
        </template>
      </b-table>
      <div class="d-flex justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="contragents_search_results.length"
          :per-page="perPage"
          :hide-goto-end-buttons="true"
        ></b-pagination>
      </div>
      <div class="text-center">
        <!-- legacy save search button, don't know exactly if it works <button class="btn btn-outline-success btn-round btn-sm mr-2" v-if="!hide_save_button" @click="saveSearch">{{$t('message.contracts.save_search')}}</button> -->
        <button
          class="btn btn-outline-success btn-round btn-sm mr-2"
          :disabled="is_save_search_results_disabled"
          @click="saveSearchNew"
        >
          {{ $t("message.contracts.save_search") }}
        </button>
        <button
          class="btn btn-success btn-round btn-sm"
          @click.stop.prevent="$bvModal.show('modal-send-email')"
        >
          {{ $t("message.contracts.send_notifications") }}
        </button>
      </div>
    </div>
    <div
      v-if="
        typeof saved_searches === 'object' &&
        saved_searches.length > 0 &&
        !hide_save_button
      "
    >
      <h5>{{ $t("message.contracts.saved_searches") }}</h5>
      <b-table
        responsive
        :fields="saved_searches_fields"
        :items="saved_searches"
      >
      </b-table>
    </div>
    <div
      v-if="
        typeof saved_contr_searches === 'object' &&
        saved_contr_searches.length > 0
      "
      class="mt-3 bg-light p-3"
      style="
        margin: 0 -1rem;
        margin-bottom: -1.875rem;
        border-bottom-left-radius: 0.625rem;
        border-bottom-right-radius: 0.625rem;
      "
    >
      <h6>
        {{ $t("message.contracts.saved_searches") }}
        <button class="btn btn-sm btn-link" @click="load_searched_results">
          <i class="fa fa-sync"></i>
        </button>
      </h6>
      <b-table
        responsive
        :fields="saved_contr_searches_fields"
        :items="saved_contr_searches"
      >
      </b-table>
    </div>

    <b-modal
      id="modal-send-email"
      hide-footer
      :title="$t('message.contracts.send_notifications')"
      size="lg"
    >
      <div class="row">
        <div class="col-12">
          <strong>
            {{ $t("message.notifications.OrgName") }}: <br />
            <span
              class="badge badge-info mr-2"
              v-for="(selected, i) in selected_search_results"
              :key="i"
            >
              {{ selected.name }}
            </span>
          </strong>
        </div>
        <div class="col-12 mt-2">
          <strong>
            {{ $t("message.notifications.Title") }}: <br />
            <input type="text" class="form-control" :value="subject" disabled />
          </strong>
        </div>
        <div class="col-12 mt-2">
          <strong>
            <div
              id="message-editor"
              contenteditable="true"
              class="bg-light p-4 text-justify"
              v-html="message"
            ></div>
          </strong>
        </div>
        <div class="col-12 mt-3text-center">
          <button class="btn btn-success" @click.stop.prevent="submit_messages">
            {{ $t("message.contracts.offer_answer_send") }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import JsonViewer from "vue-json-viewer";
export default {
  components: { JsonViewer },
  data() {
    return {
      identifier: "",

      subject: "Invite to ATTIS from {my_company}",

      /*message: `Уважаемый представитель компании <span class="badge badge-default">{company}</span>!<br>
Трансграничная электронная система <a href="https://attistrade.kz">АТТИС</a> объединяет экспортеров и импортеров, перевозчиков, экспедиторов, таможенных брокеров и банки по обе стороны границы на общей электронной платформе, обеспечив единое окно для подачи электронных документов в государственные органы на каждом этапе международной сделки. <br>
<a href="[user_profile]">Пользователь АТТИС</a> предлагает Вам зарегистрироваться на платформе, чтобы у вас была возможность получить доступ к информации системы, ее сервисам, обсудить и заключить с данным пользователем внешнеторговый контракт.<br>
Зарегистрироваться Вы сможете, перейдя по <a href="https://www.attistrade.kz/ru#/sign-up">ссылке</a>.
<br><br>
Dear representative of <span class="badge badge-default">{company}</span>!<br>
Transborder electronic system <a href="https://attistrade.kz">ATTIS</a> connects exporters and importers, carriers, freight forwarders, customs brokers, and banks on both sides of a border in a common e-platform. This provides a single window to submit e-documents to Government authorities on every stage of a foreign trade transaction. <br>
<a href="[user_profile]">The ATTIS user</a> invites You to register on the platform to be able to get an access to the system information, the system services, to negotiate and to sign foreign trade contract with this user.<br>
You can pass through the registration procedure by clicking the following <a href="https://www.attistrade.kz/en#/sign-up">link</a>`,*/
      message: `尊重的 <span class="badge badge-default">{company}</span> 代表！
跨境电子系统<a href="https://attistrade.cn">ATTIS</a>(啊提斯)通过电子平台将边境两侧的出口商和进口商、承运商、货运代理、
报关行和银行连接起来。这为在国际交易的每个阶段向政府机构提交电子文件提供了一站式服务。
<a href="[user_profile]">ATTIS</a>用户邀请您在平台上注册，以便能够访问系统信息、系统服务，与该用户进行谈判和签订
外贸合同。
<a href="https://attistrade.cn">您可以通过下面的链接进行注册</a>。
<br><br>
Уважаемый представитель компании <span class="badge badge-default">{company}</span>!
Трансграничная электронная система <a href="https://attistrade.kz">АТТИС</a> объединяет экспортеров и импортеров, 
перевозчиков, экспедиторов, таможенных брокеров и банки по обе стороны границы на 
общей электронной платформе, обеспечив единое окно для подачи электронных 
документов в государственные органы на каждом этапе международной сделки.
<a href="[user_profile]">Пользователь АТТИС</a> предлагает Вам зарегистрироваться на платформе, чтобы у вас 
была возможность получить доступ к информации системы, ее сервисам, обсудить и 
заключить с данным пользователем внешнеторговый контракт.
Зарегистрироваться Вы сможете, перейдя <a href="https://attistrade.kz">по ссылке</a>.
<br><br>
Dear representative of {company}!
Transborder electronic system <a href="https://attistrade.kz">ATTIS</a> connects exporters and importers, carriers, freight 
forwarders, customs brokers, and banks on both sides of a border in a common e-platform. This
provides a single window to submit e-documents to Government authorities on every stage of a 
foreign trade transaction.
The <a href="[user_profile]">ATTIS user</a> invites You to register on the platform to be able to get an access to the system
information, the system services, to negotiate and to sign foreign trade contract with this user.
You can pass through the registration procedure by clicking <a href="https://attistrade.kz">the following link</a>`,
      hide_save_button: false,
      contragents_search_results: [],
      saved_searches: [],
      perPage: 20,
      china_json_data: "",
      current_bin: "",
      currentPage: 1,
      search_loading: false,
      contrsearch_country_focus: false,
      countries: [],
      attis_contragents: {
        country: { value: "" },
        city: "",
        sphere: "",
        name: "",
        search_other: false,
      },
      search_results_fields: [
        {
          key: "id",
          label: this.$t("message.contracts.contragents_search_id"),
        },
        {
          key: "country",
          label: this.$t("message.contracts.contragents_search_country"),
        },
        {
          key: "name",
          label: this.$t("message.contracts.contragents_search_name"),
        },
        {
          key: "email",
          label: this.$t("message.contracts.contragents_search_email"),
        },
        {
          key: "contact",
          label: this.$t("message.contracts.contragents_search_contact"),
        },
        {
          key: "sphere",
          label: this.$t("message.contracts.contragents_search_sphere"),
        },
        {
          key: "checked",
          label: this.$t("message.contracts.contragents_search_checked"),
        },
      ],
      saved_searches_fields: [
        {
          key: "date",
          label: this.$t("message.contracts.saved_searches_date"),
        },
        {
          key: "number_results",
          label: this.$t("message.contracts.saved_searches_number_of_results"),
        },
      ],

      saved_contr_searches: [],
      saved_contr_searches_fields: [
        {
          key: "name",
          label: this.$t("message.contracts.contragents_search_name"),
        },
        {
          key: "email",
          label: this.$t("message.contracts.contragents_search_email"),
        },
        {
          key: "date",
          label: this.$t("message.contracts.saved_searches_date"),
        },
      ],
    };
  },
  methods: {
    /*
				🆕 method to save selected search results (only those, that have been checkboxed)
			*/
    saveSearchNew() {
      axios
        .post(
          window.base +
            "/contract/saveSearchContrResults?contact_id=" +
            this.identifier,
          this.selected_search_results.map((company) => {
            return { id: company.id, name: company.name, email: company.email };
          }),
        )
        .then(() => {
          new Noty({
            theme: "light",
            type: "success",
            text: this.$t("message.message.success"),
            timeout: 5000,
          }).show();
          this.load_searched_results();
        })
        .catch((error) => {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.message.no_success") + " (" + error + ")",
            timeout: 5000,
          }).show();
          this.load_searched_results();
        });
    },
    /**
     * 🤖 method to load list of saved search results
     */
    load_searched_results() {
      axios
        .get(
          window.base +
            "/contract/loadSearchContrResults?contact_id=" +
            this.identifier,
        )
        .then((response) => {
          this.saved_contr_searches = response.data;
        });
    },
    check_aml() {
      // if(typeof this.selected_search_results[0] != 'undefined')
      axios
        .get(window.base + "/admin/GetBillingServiceInfo?code=1")
        .then((response) => {
          this.$bvModal
            .msgBoxConfirm(
              this.$t("message.contracts.check_contragent_price_alert") +
                " " +
                response.data.billing_service_price +
                " " +
                response.data.billing_service_cur,
              {
                title: this.$t("message.confirm"),
                size: "md",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: this.$t("message.yes"),
                cancelTitle: this.$t("message.no"),
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
              },
            )
            .then((value) => {
              if (value) {
                for (var i in this.selected_search_results)
                  window.open(
                    this.$router.options.base +
                      "#/app/aml/" +
                      this.selected_search_results[i].name,
                    "_blank",
                  );
              }
            });
        });
    },
    submit_messages() {
      var message = document.querySelector("#message-editor").innerHTML;
      axios.get(window.base + "/document/getfirmfull").then((response) => {
        let { org_name: organization } = response.data.organizations;

        const today = new Date();
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        const yyyy = today.getFullYear();

        this.selected_search_results.forEach((recipient) => {
          var tmp = message
            .replaceAll("{company}", recipient.name)
            .replaceAll("{my_company}", organization)
            .replaceAll(
              "[user_profile]",
              "https://attistrade.kz/ru/#/profile/" + this.current_bin,
            )
            .replaceAll(
              "[user_profile]",
              "https://attistrade.kz/ru/#/profile/" + this.current_bin,
            );
          let subject = this.subject
            .replaceAll("{company}", recipient.name)
            .replaceAll("{my_company}", organization);
          var fd = new FormData();
          fd.append("email", recipient.email);
          fd.append("subject", subject + " " + dd + "." + mm + "." + yyyy);
          fd.append("message", tmp);
          axios
            .post(window.base + "/contract/sendEmail", fd)
            .then((response) => {
              this.$bvModal.hide("modal-send-email");
              new Noty({
                theme: "light",
                type: "success",
                text: this.$root.$t("message.message.invite-ok"),
                timeout: 5000,
              }).show();
            });
        });
      });
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
          // this.$data[var_name] = response.data
        });
    },
    fetchContragents(search, loading) {
      this.getLibrary("company", search, 100);
    },
    contragFocused() {
      this.contragent_focused = true;
    },
    contragBlurred() {
      this.contragent_focused = false;
      // this.validateField('company_status')
    },
    contrsearch_country_Focused() {
      this.contrsearch_country_focus = true;
    },
    contrsearch_countryBlurred() {
      this.contrsearch_country_focus = false;
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 100);
    },

    searchContr() {
      this.search_loading = true;
      var formData = new FormData();
      formData.append("org_residency", this.attis_contragents.country.value);
      formData.append("company_address", this.attis_contragents.city);
      formData.append("company_main_sphere", this.attis_contragents.sphere);
      formData.append("org_name", this.attis_contragents.name);
      formData.append("search_other", this.attis_contragents.search_other);
      axios
        .post(
          window.base + "/contract/searchContr?contract_id=" + this.identifier,
          formData,
        )
        .then((response) => {
          this.contragents_search_results = response.data;
          this.search_loading = false;
          if (this.$route.name !== "find-a-partner-result")
            this.$router.push({
              name: "find-a-partner-result",
              params: {
                search_other: this.attis_contragents.search_other,
                org_name: this.attis_contragents.name,
                org_residency: this.attis_contragents.country,
                company_address: this.attis_contragents.city,
                company_main_sphere: this.attis_contragents.sphere,
              },
            });
        });
    },
    saveSearch() {
      var formData = new FormData();
      formData.append("org_residency", this.attis_contragents.country.value);
      formData.append("company_address", this.attis_contragents.city);
      formData.append("company_main_sphere", this.attis_contragents.sphere);
      formData.append("org_name", this.attis_contragents.name);
      formData.append("search_other", this.attis_contragents.search_other);
      axios
        .post(
          window.base +
            "/contract/saveSearchContr?contact_id=" +
            this.identifier,
          formData,
        )
        .then((response) => {
          this.loadSavedSearches();
        });
    },
    loadSavedSearches() {
      // if(typeof this.$route.params.id !=='undefined')
      axios
        .get(
          window.base +
            "/contract/loadSavedSearches?contract_id=" +
            this.identifier,
        )
        .then((response) => {
          this.saved_searches = response.data;
        });
      // else
      // this.hide_save_button = true
    },
  },
  mounted() {
    // if(this.$route.params && this.$route.params.id)
    // 	this.identifier = this.$route.params.id
    // else
    this.identifier = this.$store.state.user.id;
    this.fetchContragents("");
    this.fetchCountries("");
    // this.loadSavedSearches('')
    axios.get(window.base + "/document/getFirm").then((response) => {
      this.current_bin = response.data.org_code;
    });
    this.load_searched_results();

    if (this.$route.name == "find-a-partner-result") {
      this.attis_contragents.search_other = this.$route.params.search_other;
      this.attis_contragents.name = this.$route.params.org_name;
      this.attis_contragents.country = this.$route.params.org_residency;
      this.attis_contragents.city = this.$route.params.company_address;
      this.attis_contragents.sphere = this.$route.params.company_main_sphere;

      this.searchContr();
    }
  },
  computed: {
    /**
     * 🤖 computed property to determine if the save selected search results button should be enabled or disabled
     */
    is_save_search_results_disabled() {
      if (this.selected_search_results.length > 0) return false;
      return true;
    },
    aml_disabled() {
      return this.selected_search_results.length == 0;
    },
    selected_search_results() {
      var d = [];
      if (typeof this.contragents_search_results == "object")
        this.contragents_search_results.forEach((item) => {
          if (item.checked === true) d.push(item);
        });
      return d;
    },
  },
};
</script>
